// The hero image can be added to the src folder with the HeroImage.png name.
// Logo image can be added to the src folder as Logo.png
// Favicon image can be added to the public folder as favicon.ico

// Project specific values that can be changed easily.
export const projectConfiguration = {
  // Product Key
  productKey: "testcode",

  // Content variables
  heroLineOne: "WE BUILD",
  heroLineTwo: "DELIGHTFUL",
  heroLineThree: "EXPERIMENTS",
  subtitle:
    "Be first to hear about our next drop!",

  // Colors
  backgroundColor: "#0F1118",
  primaryTextColor: "#ffffff",
  secondaryTextColor: "#9FA4BC",
  tertiaryTextColor: "#D0D4EA",
  inputBackgroundColor: "#595D6F",
  inputFocusBackgroundColor: "#ffffff",
  inputTextColor: "#595D6F",
  inputFocusTextColor: "#0D0F14",
  punchColor: "#F504F5", // Used as link color
  footerLinkColor: "#ffffff",
  buttonTextColor: "#ffffff",

  //   Fonts
  primaryFont: "Poppins",
  secondaryFont: "Inter",
};
